import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../utils/axiosInstance";

const REFRESH_MS = 30 * 60 * 1000;

/**
 * The instance's subscription (licensing/views.py): status, tier,
 * max_companies (null = unlimited), companies_used, days_left, message.
 * Null until loaded, and while signed out.
 */
export default function useLicenseStatus() {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const [license, setLicense] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get("/license/status/", { skipCompany: true });
      setLicense(data);
    } catch {
      // The banner is informational; the API still enforces the license.
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      setLicense(null);
      return undefined;
    }
    load();
    const timer = setInterval(load, REFRESH_MS);
    window.addEventListener("focus", load);
    return () => {
      clearInterval(timer);
      window.removeEventListener("focus", load);
    };
  }, [isAuthenticated, load]);

  return license;
}
